import { FC, useEffect } from "react";

import { AnalyticsEvent } from "@repo/edtech-analytics";
import { getUploadUrl } from "@repo/edtech-api";
import { ArrowDownAndBracketTrailingIcon, FolderOpenIcon } from "@repo/edtech-assets";
import { SnackBarType } from "@repo/edtech-ui-kit";
import clsx from "clsx";

import {
  ExtendedLesson,
  TrackFn,
  useSnackbar,
} from "../../../../model";
import { t } from "../../../../origins";

import st from "./Folder.module.scss";


type Props = {
  lesson: ExtendedLesson,
  onFinishLesson: TrackFn,
  className?: string,
};

export const Folder: FC<Props> = ({
  lesson,
  onFinishLesson,
  className,
}) => {
  const { showSnackbar } = useSnackbar();

  useEffect(() => {
    onFinishLesson(
      { type: AnalyticsEvent.Completed }, true, true,
    );
  }, [ onFinishLesson ]);

  const handleClick = (file: string) => {
    if (!file) {
      showSnackbar(
        `Не удалось загрузить урок ${lesson.title}`, SnackBarType.Error, "Попробуйте еще раз",
      );
    }
    onFinishLesson({ type: AnalyticsEvent.Downloaded });
  };

  return (
    <div className={clsx(st.folder, className)}>
      {
        lesson.preview && (
          <img
            alt=""
            className={st.preview}
            src={getUploadUrl(lesson.preview)}
          />
        )
      }
      <div className={st.content}>
        <FolderOpenIcon className={st.icon} />
        <h2 className={st.title}>
          {t("folder.title")}
        </h2>
        <p className={st.description}>
          {t("folder.description")}
        </p>
        <a
          download
          className={st.link}
          href={
            lesson.file ?
              getUploadUrl(lesson.file) :
              undefined
          }
          onClick={() => handleClick(lesson.file)}
        >
          <ArrowDownAndBracketTrailingIcon />
          {" "}
          {t("folder.downloadButton")}
        </a>
      </div>
    </div>
  );
};
